import React from 'react';
class GetInvoice extends React.Component {

    constructor(props) {
        super(props);
        this.state = props.temp;
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }


    handleOpen(order,date) {
        // this.setState({open: true, selectedOrder: order,date:date,mainKey:order[0].mainKey});
    }

    handleClose() {
        this.setState({open: false});
    }


    render() {
            return (
                <div className="customTableInvoice" id="toDownloadPdf">
                    <header className="clearfix">
                        <div id="logo">
                            <img alt="logo" src="https://khula.co.za//images/agric_logo.svg"/>
                        </div>
                        <div id="company">
                            <h2 className="name">KHULA</h2>
                            <div>28 Bompas Road</div>
                            <div>(+27) 783890395</div>
                            <div><a href="mailto:info@khula.com">info@khula.com</a></div>
                        </div>
                    </header>
                    <main>
                        <div id="details" className="clearfix">
                            <div id="client">
                                <div className="to">INVOICE TO:</div>
                                <h2 className="name">{this.state.profile.name}</h2>
                                <div className="address">{this.state.profile.location}</div>
                                <div className="email"><a
                                    href="mailto:john@example.com">{this.state.profile.email}</a>
                                </div>
                            </div>
                            <div id="invoice">
                                <h1 id="invoiceNumber">INVOICE DASH {this.state.invoices.voucher.id}</h1>
                                <div className="date" id="start"></div>
                                <div className="date due">Generated Date: {(this.state.invoices.voucher.assignedDate)}</div>
                            </div>
                        </div>
                        <table border="0" cellspacing="0" cellpadding="0" className="table">
                            <thead>
                            <tr>
                                <th className="no">#</th>
                                <th className="description">FARMER NAME</th>
                                <th className="unit">QUANTITY</th>
                                <th className="qty">UNIT PRICE</th>
                                <th className="total">TOTAL</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="no">{1}</td>
                                    <td className="desc">{this.state.invoices.voucher.farmerDetails.name+" "+this.state.invoices.voucher.farmerDetails.surname}</td>
                                    <td className="unit">{1}</td>
                                    <td className="qty">R{this.state.invoices.voucher.value} </td>
                                    <td className="total">R{this.state.invoices.voucher.assignedAmount}</td>
                                </tr>


                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="3"></td>
                                <td colspan="1">SUBTOTAL</td>
                                <td>R{this.state.invoices.voucher.assignedAmount}</td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <td colspan="1">VAT 0%</td>
                                <td>R0.00</td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <td colspan="1">GRAND TOTAL</td>
                                <td>R{this.state.invoices.voucher.assignedAmount}</td>
                            </tr>
                            </tfoot>
                        </table>
                        <div id="thanks">Thank you for your business!</div>

                    </main>
                </div>);
    }
}

// GetInvoice.propTypes = propTypes;

export default GetInvoice;



// WEBPACK FOOTER //
// ./src/components/GetInvoice.js